
import { applyForDip, canDoDip, canDoDipNoProperty, getDipCert, getDipStatus, submitDip, submitNoPropertyDip } from '../api/dip'
import { Resolvers } from '../generated/resolvers'

const resolvers: Resolvers = {
  Mutation: {
    submitDip: async (_parent, { payloadInput, queryInput }) => await submitDip(payloadInput, queryInput),
    submitNoPropertyDip: async (_parent, { payloadInput, queryInput }) =>
      await submitNoPropertyDip(payloadInput, queryInput),
    getDipCert: async (_parent, { id, mortgageId, case: _case }) => await getDipCert(id, _case, mortgageId),
  },
  Query: {
    canDoDip: async (_parent, { input }) => await canDoDip(input),
    canDoDipNoProperty: async (_parent, { input }) => await canDoDipNoProperty(input),
    getDipStatus: async (_parent, { input }) => await getDipStatus(input),
    applyForDip: async (_parent, { id, mortgageId, reservation }) => await applyForDip(id, mortgageId, reservation),
  },
}

export default resolvers
